// Dashboard State
import { DeviceRow } from '../../services/device.service';

export type ConnectionStateFilter = '' | 'connected' | 'disconnected' | 'unknown';
export type StatusFilter = '' | 'enabled' | 'disabled';
export type SortKey = 'deviceId' | 'f_VER' | 'coN_FVER' | 'IoTHubName' | 'connectionState' | 'lastActivityTime' | 'status' | 'environment' | 'deviceTypeName';
export type SortDirection = 'asc' | 'desc' | null;

export interface DashboardFilters {
  connectionState: ConnectionStateFilter;
  status: StatusFilter;
  hubName: string;
  environment: string;
  deviceType: string;
}

export interface DashboardState {
  // Data
  rows: DeviceRow[];
  filteredRows: DeviceRow[];
  
  // Pagination
  total: number;
  pageSize: number;
  currentPage: number;
  hasMore: boolean;
  nextCursor: string | null;
  
  // Search
  searchQuery: string;
  appliedQuery: string;
  
  // Filters
  filters: DashboardFilters;
  hubOptions: string[];
  environmentOptions: string[];
  deviceTypeOptions: string[];
  
  // Sorting
  sortKey: SortKey | null;
  sortDirection: SortDirection;
  
  // Loading states
  loading: boolean;
  refreshing: boolean;
  error: string | null;
  
  // Device type mapping
  deviceTypeMap: Record<string, string>;
}

export const initialDashboardFilters: DashboardFilters = {
  connectionState: '',
  status: '',
  hubName: '',
  environment: '',
  deviceType: '',
};

export const initialDashboardState: DashboardState = {
  rows: [],
  filteredRows: [],
  
  total: 0,
  pageSize: 50,
  currentPage: 1,
  hasMore: false,
  nextCursor: null,
  
  searchQuery: '',
  appliedQuery: '',
  
  filters: initialDashboardFilters,
  hubOptions: [],
  environmentOptions: [],
  deviceTypeOptions: [],
  
  sortKey: 'connectionState',
  sortDirection: 'asc',
  
  loading: false,
  refreshing: false,
  error: null,
  
  deviceTypeMap: {},
};
